import { IconButton, Modal } from "src/Components";
import { ReactComponent as PauseIcon } from "../../Assets/Cup-modal.svg";
import { IModalProps } from "..";
import "./ReturnPauseConfirmModal.scss";

const ReturnPauseConfirmModal: React.FC<IModalProps> = ({ isOpen, onClose, onAction }) => (
	<Modal
		isOpen={isOpen}
		title="Подтверждение действий"
		onClose={onClose}
		className="return-pause-confirm-modal"
		renderIcon={<PauseIcon />}
		renderFooter={(
			<>
				<IconButton outline onClick={onClose}>Продолжить работу</IconButton>
				<IconButton color="green" onClick={() => onAction("beginPause", "")}>Начать перерыв</IconButton>
			</>
		)}
	>
		Приостановить работу?
	</Modal>
);

export default ReturnPauseConfirmModal;
